<!--
 * @Description: 收入细项列表(提现金额明细组件)
 * @Author: sunhuihong
 * @Date: 2025-11-07 14:43:52
-->
<template>
  <div class="income-item-list">
    <el-table ref="table" :data="incomeItemList" :header-cell-style="{'background-color': '#EFF5FA', 'height': '44px'}" 
      max-height="300">
      <el-table-column prop="totalAmountYuan" label="收入金额（元）" min-width="20%" align="left"></el-table-column>
      <el-table-column prop="genTime" label="完成分账时间" min-width="30%" align="left"></el-table-column>
      <el-table-column prop="orderNo" label="订单编号" min-width="50%" align="left"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'IncomeItemList',

  props: ["incomeItemList"],

  data() {
    return {
    }
  },

  methods: {
  },
}
</script>

<style scoped>
.income-item-list {
  margin: 8px 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/incometaxlist/IncomeItemList.vue